import React, {useState} from 'react';

import styles from './styles.module.scss';

export const ArticleCoverBlock = ({
    coverUrl,
    title,
    defaultText = '#TESTUНовости',
    defaultImage
}) => {
    const [imageError, setImageError] = useState(false);

    return (
        <div className={styles.media}>
            {(coverUrl || defaultImage) && !imageError ? (
                <img
                    src={coverUrl || defaultImage}
                    alt={title}
                    className={styles.image}
                    onError={(event) => {
                        if (coverUrl && defaultImage && event.currentTarget.src !== defaultImage) {
                            event.currentTarget.src = defaultImage;
                            return;
                        }

                        setImageError(true);
                    }}
                />
            ) : (
                <div className={styles.fallback}>{defaultText}</div>
            )}
        </div>
    );
};
